

























































































































































import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import OrderLine from '@/models/order/OrderLine'
import { vxm } from '@/store'

type Group = {
  id: string
  orderLines: OrderLine[]
  createMethod: 'existing' | 'new'
  productId: string
  quantity: number
}

@Component({
  components: {},
})
export default class MountCompleteWheelsDialog extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  private value: boolean

  @Prop({ type: Number, required: true })
  private orderId: number

  private orderLines: OrderLine[] = []
  private groups: Group[] = []
  private draggedItem: OrderLine | null = null

  private isSubmitting = false

  private created() {
    this.$axios.get('v4/site/order/' + this.orderId + '/lines').then((response) => {
      this.orderLines = response.data.data.map((line: any) => new OrderLine(line))
    })
  }

  private get visible() {
    return this.value
  }

  private set visible(value) {
    this.$emit('input', value)
  }

  private get ungroupedOrderLines(): OrderLine[] {
    const groupedIds = this.groups.flatMap((group) => group.orderLines.map((line) => line.id))
    return this.orderLines.filter((line) => !groupedIds.includes(line.id) && [1, 2, 45].includes(line.productType))
  }

  private createNewGroup() {
    const newGroup: Group = {
      id: Date.now().toString(),
      orderLines: [],
      createMethod: 'existing',
      productId: '',
      quantity: 0,
    }
    this.groups.push(newGroup)
  }

  private removeGroup(groupIndex: number) {
    this.groups.splice(groupIndex, 1)
  }

  private startDrag(line: OrderLine) {
    this.draggedItem = line
  }

  private isValidDrop(group: Group): boolean {
    if (!this.draggedItem) return false

    const productType = this.draggedItem.productType
    const groupTypes = group.orderLines.map((line) => line.productType)

    // Check if adding this item would violate group rules
    if (productType === 1) {
      // Can only have one productType = 1
      return !groupTypes.includes(1)
    } else if (productType === 2) {
      // Can only have one productType = 2
      return !groupTypes.includes(2)
    } else if (productType === 45) {
      // Can only have one productType = 45
      return !groupTypes.includes(45)
    }

    return false // Only allow types 1, 2, 45
  }

  private dropItem(group: Group, event: DragEvent) {
    event.preventDefault()
    if (this.draggedItem && this.isValidDrop(group)) {
      group.orderLines.push(this.draggedItem)
      this.draggedItem = null
    }
  }

  private removeFromGroup(group: Group, line: OrderLine) {
    const index = group.orderLines.findIndex((l) => l.id === line.id)
    if (index > -1) {
      group.orderLines.splice(index, 1)
    }
  }

  private isGroupValid(group: Group): boolean {
    const types = group.orderLines.map((line) => line.productType)
    const hasType1 = types.includes(1)
    const hasType2 = types.includes(2)
    const hasType45 = types.includes(45)

    // Must have exactly one type 1 and one type 2
    // Can have 0 or 1 type 45
    return hasType1 && hasType2 && types.filter((t) => t === 45).length <= 1
  }

  private getGroupValidationMessage(group: Group): string {
    const types = group.orderLines.map((line) => line.productType)
    const hasType1 = types.includes(1)
    const hasType2 = types.includes(2)
    const type45Count = types.filter((t) => t === 45).length

    if (!hasType1 && !hasType2) {
      return this.$t('Group needs one tire and one rim')
    } else if (!hasType1) {
      return this.$t('Group needs one tire (productType 1)')
    } else if (!hasType2) {
      return this.$t('Group needs one rim (productType 2)')
    } else if (type45Count > 1) {
      return this.$t('Group can have at most one TPMS (productType 45)')
    }

    return ''
  }

  private getProductTypeClass(productType: number): string {
    switch (productType) {
      case 1:
        return 'product-type-1'
      case 2:
        return 'product-type-2'
      case 45:
        return 'product-type-45'
      default:
        return 'product-type-other'
    }
  }

  private getProductTypeColor(productType: number): string {
    switch (productType) {
      case 1:
        return 'blue'
      case 2:
        return 'green'
      case 45:
        return 'orange'
      default:
        return 'grey'
    }
  }

  private getProductTypeName(productType: number): string {
    switch (productType) {
      case 1:
        return this.$t('Tire')
      case 2:
        return this.$t('Rim')
      case 45:
        return this.$t('TPMS')
      default:
        return this.$t('Other')
    }
  }

  private get canSubmit(): boolean {
    // All groups must be valid
    const allGroupsValid = this.groups.length > 0 && this.groups.every((group) => this.isGroupValid(group))
    if (!allGroupsValid) return false

    // All groups must have product selection configured
    return this.groups.every((group) => {
      if (group.createMethod === 'existing') {
        return group.productId.trim() !== ''
      }
      return group.createMethod === 'new'
    })
  }

  private submit() {
    this.isSubmitting = true

    const data = {
      orderId: this.orderId,
      groups: this.groups.map((group) => ({
        orderLineIds: group.orderLines.map((line) => line.id),
        createMethod: group.createMethod,
        productId: group.createMethod === 'existing' ? group.productId : null,
        quantity: group.quantity,
      })),
    }

    this.$axios
      .post('/v4/site/products/complete-wheel-mount', data)
      .then((response) => {
        console.log(response)
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, 'Error on mounting complete wheel')
      })
      .finally(() => {
        this.isSubmitting = false
      })
  }
}
